import { CustomParams } from '@app/entities/request-settings';
import { UserInfo } from '@app/modules/core/interfaces/user';
import { StatsigExperimentsConfig } from '@statsig/statsig.entities';

export const customParamsMapper = 
  (userInfo: UserInfo, userExperiments: StatsigExperimentsConfig[]): CustomParams[] => {
    const customParamObject = [];
    if (userInfo) {
      Object.entries(userInfo).forEach(([key, value]) => {
        if (includesUserInfoProperties(key)) {
          /* NEW NETACTICA FRAMEWORK TYPES: 
            Esta lógica se debe eliminar cuando se ajuste la definción de Custom Params por parte de Netactica */
          customParamObject.push({Key: key, Value: value.toString()});
        }
      })
    }
    if (userExperiments?.length > 0) {
      userExperiments.forEach(experiments => {
        customParamObject.push({Key: experiments.name, Value: experiments.treatment.toString()});
      })
    }
    return customParamObject;
  }


const includesUserInfoProperties = (key: string): boolean => {
  const userInfoProperties = [
    'application_user_id', 'has_rappicard', 'is_prime', 'loyalty_level', 'rappi_segment', 'level_prime'
  ];
  return userInfoProperties.includes(key);
}
